import { create } from "zustand";

type SearchBarState = {
  textToSearch: string;
}

export const searchBarState = create<SearchBarState>(() => ({
  textToSearch: ""
}));

export const updateTextOfSearchBar = (text: string) =>
  searchBarState.setState(() => ({ textToSearch: text }));